import { fetchApi, getTeamsBaseUrl } from 'state/services/apiService';
import { AUTH_TYPES } from 'auth/state/service/authApi';

export function autoCompleteApiService() {
  return fetchApi({
    url: `${getTeamsBaseUrl()}/autocomplete`,
    authType: AUTH_TYPES.BEARER,
  })
    .then(res => res.json())
    .catch(err => {
      console.log(err);
      throw err;
    });
}



// WEBPACK FOOTER //
// ./src/state/services/autocompleteApi.js